import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { PreviewIncidentReportResponse } from '@roadfootage/api-client'

export const useDiscoveryStore = defineStore('discovery', () => {
  const zoom = ref<number>(5)
  const center = ref<[number, number]>([-25.39, 134.82])

  const selectedFeature = ref<any>(null)
  const popupIncident = ref<PreviewIncidentReportResponse | null>(null)
  const clusterIncidents = ref<PreviewIncidentReportResponse[]>([])
  const clusterNearbyAddress = ref<string | null>(null)

  function closePopup() {
    selectedFeature.value = null
    popupIncident.value = null
    clusterIncidents.value = []
    clusterNearbyAddress.value = null
  }

  return {
    zoom,
    center,
    selectedFeature,
    popupIncident,
    clusterIncidents,
    clusterNearbyAddress,
    closePopup
  }
})
